import { Avatar, Box } from "@mui/material";
import React from "react";
import HeadingSubHeading from "../../common/HeadingSubHeading/HeadingSubHeading";
import stringAvatar from "../../utils/StringAvatar";
import { CustomerListingCardStyles } from "./CustomerListingCardStyles";

interface CustomerListingCardProps {
  name: string;
  entityType: string;
  address: string;
}

const CustomerListingCard: React.FC<CustomerListingCardProps> = ({
  name,
  entityType,
  address,
}) => {
  return (
    <Box sx={CustomerListingCardStyles.container}>
      <Box sx={CustomerListingCardStyles.header}>
        <Box sx={CustomerListingCardStyles.avatar}>
          <Avatar {...stringAvatar(name)} />
          <Box sx={CustomerListingCardStyles.headingContainer}>
            <HeadingSubHeading
              headingAdditionalClassName={
                CustomerListingCardStyles.avatarheadingText
              }
              containerAdditionalClassName={CustomerListingCardStyles.heading}
              subHeadingAdditionalClassName={
                CustomerListingCardStyles.subHeadingPolicyText
              }
              heading={name}
              subheading={entityType}
            />
          </Box>
        </Box>
      </Box>
      <Box sx={CustomerListingCardStyles.headingContainer}>
        <HeadingSubHeading
          heading={address}
          headingAdditionalClassName={
            CustomerListingCardStyles.headingStatusText
          }
          containerAdditionalClassName={CustomerListingCardStyles.status}
          subHeadingAdditionalClassName={
            CustomerListingCardStyles.subHeadingText
          }
          subheading=""
        />
      </Box>
    </Box>
  );
};

export default CustomerListingCard;
